import React, { useEffect, useState } from "react";
import NoDataMessage from "../../components/NoDataMessage";
import { useConfig } from "@eis-poc/lib-discover-medical-mfes";
import { Content } from "./_.styled";

const AhfsContent = ({ slugTitle }) => {
  const [htmlContent, setHtmlContent] = useState("");
  const [error, setError] = useState(false);
  const config = useConfig();

  useEffect(() => {
    const loadHtml = async () => {
      try {
        const response = await fetch(
          `https://${config.assetsBaseUrl}/ahfs/${slugTitle}.html`
        );

        if (!response.ok || response.status !== 200) {
          throw new Error();
        }

        const html = await response.text();
        setHtmlContent(html);
      } catch (err) {
        setError(true);
      }
    };

    if (config?.assetsBaseUrl) {
      loadHtml();
    }
  }, [slugTitle, config?.assetsBaseUrl]);

  if (error || !config?.assetsBaseUrl) {
    return <NoDataMessage message="We're sorry! This page doesn't exist." />;
  }

  return <Content>{htmlContent}</Content>;
};

export default AhfsContent;
